import React from "react";
import PropTypes from "prop-types";
import { BsTelephoneInboundFill, BsTelephoneOutbound } from "react-icons/bs";

import PriorityBadge from "../shared/PriorityBadge";
import SmallStatusBadge from "../shared/SmallStatusBadge";
import { TableAlert } from "./TableAlert";
import TaskTags from "../components/task/TaskTags";

const propTypes = {
  data: PropTypes.object.isRequired,
  taskHandler: PropTypes.func.isRequired,
};

const Row = (props) => {
  function renderCallData() {
    return (
      <>
        <br />
        <b>
          <BsTelephoneOutbound className="phone-number-icon" />
          From{" "}
        </b>
        {props.data.phone_call.from}
        {"   "}
        <b>
          <BsTelephoneInboundFill className="phone-number-icon ml5" />
          To{" "}
        </b>
        {props.data.phone_call.to}
      </>
    );
  }

  let waitingLabelSetAt = null;

  if (props.data.waiting_label_set_at) {
    waitingLabelSetAt = new Date(props.data.waiting_label_set_at);
    waitingLabelSetAt = waitingLabelSetAt.toDateString();
  }

  return (
    <React.Fragment key={props.data.id + props.data.task_type}>
      <tr
        onClick={(e) => {
          props.taskHandler(props.data.id);
        }}
      >
        <td id="type">
          <SmallStatusBadge status={props.data.status} /> {" #" + props.data.id + ": "}
          {props.data.label}
          {(props.data.task_type == "abandoned_calls" ||
            props.data.task_type == "voicemail_calls" ||
            props.data.task_type == "outbound_calls" ||
            props.data.task_type == "inbound_calls") &&
            props.data.phone_call.from &&
            props.data.phone_call.to &&
            renderCallData()}
          {props.data.alert && (
            <>
              <br />
              <TableAlert alert={props.data.alert} />
            </>
          )}
          <span id="from">
            <br />
            {props.data.cpr.id && <b>CPR #{props.data.cpr.id}: </b>}
            {props.data.procedure_type || props.data.cpr.procedure_type}
            {props.data.waiting_label && (
              <>
                <br />
                <b>Waiting Label: </b>
                {props.data.waiting_label.replaceAll("_", " ")}
                {waitingLabelSetAt && <i> Set on {waitingLabelSetAt}</i>}
              </>
            )}
            {props.data.agent_note && (
              <>
                <br />
                <b>Agent Note:</b>
                <i>
                  {props.data.agent_note_added_on && (<>{props.data.agent_note_added_on} </>)}
                  {props.data.agent_note}
                  {props.data.agent_note_added_by && (<> {props.data.agent_note_added_by}</>)}
                </i>
              </>
            )}
            {props.data.closed_by && (
              <>
                <br />
                <b>Closed By: </b>
                <i>
                  { props.data.closed_by } at { props.data.closed_at }
                </i>
              </>
            )}
          </span>
          {!!props.data.tags.length > 0 && (
            <TaskTags
              tags={props.data.tags.map((i) => {
                return { value: i, label: i.replaceAll("-", " ") };
              })}
            />
          )}
        </td>
        <td id="priority" className="right">
          <PriorityBadge priority={props.data.priority} />
        </td>
        <td>
          {new Date(props.data.created_at).toLocaleString([], {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })}
          <br />

          {new Date(props.data.created_at).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </td>
        <td id={"patient"}>
          {props.data.patient.first_name == null
            ? ""
            : props.data.patient.first_name + " " + props.data.patient.last_name}
          {props.data.patient.health_plan && (<>
            <br />
            <span className={'small'}>
              ({ props.data.patient.health_plan })
            </span>
          </>)}
        </td>
        <td id="pcp-group">{props.data.pcp_group}</td>
        <td id="assignee" className="right">
          {props.data.assignee_support_group}
        </td>
        <td id="updated">
          {new Date(props.data.updated_at).toLocaleString([], {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })}
          <br />
          {new Date(props.data.updated_at).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </td>
      </tr>
    </React.Fragment>
  );
};

Row.prototype = propTypes;
export default Row;
